import { connect } from 'react-redux';
import { RxDragHandleDots2 } from 'react-icons/rx';
import { useCallback, useState, useEffect, useRef } from 'react';
import { filter, fromEvent, tap } from 'rxjs';
import {
   DndContext,
   closestCenter,
   KeyboardSensor,
   PointerSensor,
   useSensor,
   useSensors,
} from '@dnd-kit/core';
import {
   arrayMove,
   SortableContext,
   sortableKeyboardCoordinates,
   verticalListSortingStrategy,
   useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { moveMixerTrackEffect, setView } from '../actions';
import { sequencerViewTypes } from '../constants';
import { Button } from '../../../components/Button';

const mapStateToProps = ({ activeInterface: { instrumentRack, view } }) => {
   const effects = instrumentRack[view.instrumentIndex].mixerTrack.effects;
   return {
      view,
      effects,
   };
};

const mapDispatchToProps = {
   setView,
   moveMixerTrackEffect,
};

const TrackEffectList = connect(
   mapStateToProps,
   mapDispatchToProps
)(({ view, effects, setView, moveMixerTrackEffect }) => {
   const sensors = useSensors(
      useSensor(PointerSensor),
      useSensor(KeyboardSensor, {
         coordinateGetter: sortableKeyboardCoordinates,
      })
   );

   const handleDragEnd = useCallback(
      (event) => {
         const { active, over } = event;

         if (active.id !== over.id) {
            const activeIndex = effects.findIndex(({ id }) => id === active.id);
            const overIndex = effects.findIndex(({ id }) => id === over.id);
            moveMixerTrackEffect(activeIndex, overIndex);
         }
      },
      [effects, moveMixerTrackEffect]
   );

   return (
      <div>
         <Button
            onClick={() =>
               setView({
                  viewType: sequencerViewTypes.fullMixer,
               })
            }
         >
            close
         </Button>

         <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
         >
            <SortableContext
               items={effects}
               strategy={verticalListSortingStrategy}
            >
               {effects.map(({ id, type }, index) => (
                  <SortableItem key={id} id={id} label={type}>
                     <span>
                        <FiEdit
                           onClick={() =>
                              console.log({
                                 viewType: sequencerViewTypes.mixerEffect,
                                 instrumentIndex: view.instrumentIndex,
                                 effectIndex: index,
                              }) ??
                              setView({
                                 viewType: sequencerViewTypes.mixerEffect,
                                 instrumentIndex: view.instrumentIndex,
                                 effectIndex: index,
                              })
                           }
                        />
                     </span>
                     <span>
                        <FiTrash2 />
                     </span>
                  </SortableItem>
               ))}
            </SortableContext>
         </DndContext>
         <hr />
      </div>
   );
});

export function SortableItem({ id, label, children }) {
   const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id });

   const style = {
      transform: CSS.Transform.toString(transform),
      transition,
   };

   return (
      <div ref={setNodeRef} style={style} {...attributes}>
         <span {...listeners}>
            <span data-draggable>
               <RxDragHandleDots2 />
            </span>{' '}
            {label}
         </span>
         {children}
      </div>
   );
}

export { TrackEffectList };
